@if (message) {
  <div class="motors-cannot-edit-something-message-section">
    <tg-info-box  tgStyle="primary">
      <tg-info-box-heading>Can't edit something?</tg-info-box-heading>
      {{message}}
    </tg-info-box>
  </div>
}
